if (!customElements.get('product-shipping-banner')) {
  class ProductShippingBanner extends HTMLElement {
    connectedCallback() {
      this.countdown = this.querySelector('[data-shipping-banner-countdown]');
      this.methods = Array.from(this.querySelectorAll('[data-shipping-method]'));
      this.timeZone = this.dataset.timezone || 'Europe/Stockholm';
      this.cutoffHour = Number(this.dataset.cutoffHour || 11);
      this.cutoffMinute = Number(this.dataset.cutoffMinute || 0);
      this.todayLabel = this.dataset.today || 'Today';
      this.tomorrowLabel = this.dataset.tomorrow || 'Tomorrow';
      this.months = (this.dataset.months || '').split('|');
      this.formatter = new Intl.DateTimeFormat('en-CA', {
        timeZone: this.timeZone,
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit',
        hourCycle: 'h23'
      });

      if (!this.countdown || !this.methods.length) {
        return;
      }

      this.render();
      this.interval = window.setInterval(() => this.render(), 1000);
    }

    disconnectedCallback() {
      if (this.interval) {
        window.clearInterval(this.interval);
      }
    }

    render() {
      var now = this.getZonedDate(new Date());
      var schedule = this.getSchedule(now);
      var remaining = Math.max(0, schedule.deadline.getTime() - now.getTime());

      this.countdown.textContent = this.formatDuration(remaining);

      this.methods.forEach((method) => {
        var deliveryDays = Math.max(0, Math.round(Number(method.dataset.deliveryBusinessDays || 1)));
        var deliveryDate = this.addBusinessDays(schedule.shipDate, deliveryDays);
        var shipTarget = method.querySelector('[data-shipping-banner-ship-date]');
        var deliveryTarget = method.querySelector('[data-shipping-banner-delivery-date]');

        if (shipTarget) {
          shipTarget.textContent = this.formatDate(schedule.shipDate, now);
        }

        if (deliveryTarget) {
          deliveryTarget.textContent = this.formatDate(deliveryDate, now);
        }
      });
    }

    getSchedule(now) {
      var today = this.startOfDay(now);
      var todayDeadline = this.withCutoff(today);
      var canShipToday = this.isBusinessDay(today) && now.getTime() < todayDeadline.getTime();
      var shipDate = canShipToday ? today : this.nextBusinessDay(this.addDays(today, 1));
      var deadline = canShipToday ? todayDeadline : this.withCutoff(shipDate);

      return { shipDate, deadline };
    }

    getZonedDate(date) {
      var values = {};

      this.formatter.formatToParts(date).forEach((part) => {
        if (part.type !== 'literal') {
          values[part.type] = Number(part.value);
        }
      });

      return new Date(Date.UTC(
        values.year,
        values.month - 1,
        values.day,
        values.hour,
        values.minute,
        values.second
      ));
    }

    startOfDay(date) {
      return new Date(Date.UTC(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate()));
    }

    withCutoff(date) {
      return new Date(Date.UTC(
        date.getUTCFullYear(),
        date.getUTCMonth(),
        date.getUTCDate(),
        this.cutoffHour,
        this.cutoffMinute,
        0
      ));
    }

    addDays(date, days) {
      var nextDate = new Date(date.getTime());
      nextDate.setUTCDate(nextDate.getUTCDate() + days);

      return nextDate;
    }

    isBusinessDay(date) {
      var day = date.getUTCDay();

      return day >= 1 && day <= 5;
    }

    nextBusinessDay(date) {
      var nextDate = new Date(date.getTime());

      while (!this.isBusinessDay(nextDate)) {
        nextDate = this.addDays(nextDate, 1);
      }

      return nextDate;
    }

    addBusinessDays(date, days) {
      var result = new Date(date.getTime());
      var remaining = days;

      while (remaining > 0) {
        result = this.addDays(result, 1);

        if (this.isBusinessDay(result)) {
          remaining -= 1;
        }
      }

      return result;
    }

    isSameDay(date, comparison) {
      return date.getUTCFullYear() === comparison.getUTCFullYear()
        && date.getUTCMonth() === comparison.getUTCMonth()
        && date.getUTCDate() === comparison.getUTCDate();
    }

    formatDate(date, now) {
      if (this.isSameDay(date, now)) {
        return this.todayLabel;
      }

      if (this.isSameDay(date, this.addDays(this.startOfDay(now), 1))) {
        return this.tomorrowLabel;
      }

      return [date.getUTCDate(), this.months[date.getUTCMonth()] || ''].join(' ').trim();
    }

    formatDuration(milliseconds) {
      var totalSeconds = Math.floor(milliseconds / 1000);
      var hours = Math.floor(totalSeconds / 3600);
      var minutes = Math.floor((totalSeconds % 3600) / 60);
      var seconds = totalSeconds % 60;

      return [hours, minutes, seconds].map((part) => String(part).padStart(2, '0')).join(':');
    }
  }

  customElements.define('product-shipping-banner', ProductShippingBanner);
}
